<h2 mat-dialog-title>
  {{ data.type === 'error' ? 'Erro ao solicitar relatório' : 'Relatório solicitado' }}
</h2>

<mat-dialog-content>

  <ng-container *ngIf="data.type !== 'error'">

    <p>O relatório está sendo gerado.</p>

    <p *ngIf="(data.emails?.length || 0) === 0">
      Assim que estiver pronto, ele será enviado para os e-mails cadastrados no inventário.
    </p>

    <p *ngIf="(data.emails?.length || 0) === 1">
      Assim que estiver pronto, ele será enviado para o e-mail:
      <strong>{{ data.emails[0] }}</strong>
    </p>

    <ng-container *ngIf="(data.emails?.length || 0) > 1">
      <p>Assim que estiver pronto, ele será enviado para os e-mails cadastrados:</p>
      <ul class="list-disc pl-5 my-2">
        <li *ngFor="let email of data.emails"><strong>{{ email }}</strong></li>
      </ul>
    </ng-container>

  </ng-container>

  <ng-container *ngIf="data.type === 'error'">

    <p style="color:#b91c1c;">
      Não foi possível solicitar a geração do relatório.
    </p>

    <p>
      Tente novamente em alguns instantes ou entre em contato com o suporte.
    </p>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="fechar()">
    OK
  </button>
</mat-dialog-actions>